import axios from "axios";
import preciseToSecs from "./Utils";
import { useAuth } from "../context/API_Client";

function formatDateLabel(dateLabel, dateRange) {
  const date = new Date(dateLabel);
  const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
  const oneWeekInMilliseconds = 7 * oneDayInMilliseconds;
  const oneMonthInMilliseconds = 31 * oneDayInMilliseconds;
  const fromDate = new Date(dateRange.fromDate);
  const toDate = new Date(dateRange.toDate);
  const rangeInMilliseconds = toDate - fromDate;

  let formattedDate = "";
  let formattedTime = "";
  if (
    rangeInMilliseconds > oneDayInMilliseconds &&
    rangeInMilliseconds <= oneMonthInMilliseconds
  ) {
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    formattedDate =
      days[date.getDay()] +
      " " +
      date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  } else if (rangeInMilliseconds >= oneMonthInMilliseconds) {
    formattedDate = date.toLocaleDateString("en-US", {
      month: "short",
      year: "numeric",
    });
  } else {
    formattedDate = date.toLocaleDateString("en-US");
    formattedTime = date.toLocaleTimeString("en-US", {
      timeZone: "IST",
      hour12: true,
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  if (rangeInMilliseconds <= oneDayInMilliseconds) {
    return formattedTime;
  }
  return `${formattedDate} ${formattedTime}`;
}

export function GetVisData(
  visName,
  groupKeyName,
  labelKeyName,
  valueKeyNames,
  dateRange,
  units,
  merchantId,
  accessToken,
  success,
  error
) {
  const colors = [
    "brown",
    "orange",
    "magenta",
    "green",
    "blue",
    "gray",
    "black",
    "red",
    "aqua",
    "purple",
  ];

  axios
    .post(
      `${process.env.REACT_APP_BASE_URL}/merchants/${merchantId}/visualizations/${visName}`,
      {
        calendarInterval: dateRange.calendarInterval,
        fromDate: dateRange.fromDate,
        toDate: dateRange.toDate,
        legalEntityCode: units.legalEntityCode,
        clientPosId: units.clientPosId,
      },
      {
        headers: {
          Authorization: accessToken,
        },
      }
    )
    .then((response) => {
      const labels = [
        ...new Set(
          response.data.points.map((data) => {
            return data[labelKeyName];
          })
        ),
      ];

      const formattedLabels = labels.map((label) => {
        return formatDateLabel(label, dateRange);
      });

      let cIndex = 0;
      if (groupKeyName === null) {
        success({
          labels: formattedLabels,
          datasets: valueKeyNames.map((valueKey) => {
            return {
              label:
                valueKeyNames.length > 1 ? "Overall: " + valueKey : "Overall",
              // data: response.data.points.map((data) =>  data[valueKey]),
              data: labels.map((label) => {
                const matchedData = response.data.points.filter(
                  (data) => data[labelKeyName] === label
                );
                return matchedData.length > 0
                  ? matchedData[0][valueKey]
                  : undefined;
              }),
              borderColor: colors[cIndex++],
              backgroundColor: colors[cIndex++],
            };
          }),
        });
      } else {
        const keyedData = response.data.points.reduce((group, currentData) => {
          const groupKey =
            groupKeyName.constructor === Array
              ? groupKeyName.map((key) => currentData[key]).join(":")
              : currentData[groupKeyName];
          group[groupKey] = group[groupKey] ?? [];

          group[groupKey].push(currentData);
          return group;
        }, {});

        const cData = {
          labels: formattedLabels,
          datasets: Object.keys(keyedData).flatMap((key) => {
            return valueKeyNames.map((valueKey) => {
              return {
                label: valueKeyNames.length > 1 ? key + ":" + valueKey : key,
                data: labels.map((label) => {
                  const matchedData = keyedData[key].filter(
                    (keyedDatum) => keyedDatum[labelKeyName] === label
                  );
                  return matchedData.length > 0
                    ? matchedData[0][valueKey]
                    : undefined;
                }),
                borderColor: colors[cIndex++],
                backgroundColor: colors[cIndex++],
              };
            });
          }),
        };
        // console.log(cData);
        success(cData);
      }
    })
    .catch(error);
}
